import React, {
  useState,
  useRef,
  memo,
  forwardRef,
  useEffect,
  useImperativeHandle,
} from 'react';
import { Select } from 'antd';
import { RatioSelectorOptions, FixedRatios, INTEGRATION_TYPES } from '@model';
import './colorSelector.scss';

const { Option } = Select;

const RatioCellRenderer = memo(
  forwardRef((props, ref) => {
    const type = props?.data?.type;
    const isIframe = props?.data?.iframe;
    let value = props.value;
    let disabled;
    if (['text'].includes(type) && isIframe === false) {
      disabled = true;
    } else {
      disabled = false;
    }

    if (['regular'].includes(type) && isIframe) {
      disabled = false;
    } else if (['regular'].includes(type) && !isIframe) {
      disabled = true;
    }

    if (
      ['other', 'pdf', 'imageModule', 'image', INTEGRATION_TYPES.HTML].includes(
        type,
      )
    ) {
      disabled = false;
    }

    if (['multiSection', 'widget', 'chart', 'textContainer'].includes(type)) {
      disabled = true;
    }

    if (!value && !disabled) {
      if (type === 'powerbiModule' || type === 'powerbi') {
        value = FixedRatios.AUTO;
      } else {
        value = FixedRatios.FULL;
      }
    }

    if (disabled) {
      value = 'Not Applicable';
    }
    value =
      {
        '64:27': FixedRatios.FULL,
        '16:9': FixedRatios.STANDARD,
        '32:7': FixedRatios.BANNER,
        AUTO: FixedRatios.AUTO,
      }[value] || value;

    const [ratio, setRatio] = useState(value);
    const refInput = useRef(null);

    const onRatioChange = (newRatio) => {
      setRatio(newRatio);
      props.afterChange &&
        props.afterChange(props.data.moduleId || props.data.id, {
          [props?.colDef?.field?.[0]]: newRatio,
        });
    };

    useEffect(() => {
      refInput.current.focus();
    }, []);

    useImperativeHandle(ref, () => ({
      getValue() {
        return ratio;
      },
    }));

    return (
      <Select
        ref={refInput}
        dropdownClassName="role-select-dropdown"
        value={ratio}
        dropdownMatchSelectWidth={330}
        disabled={disabled}
        onChange={onRatioChange}
      >
        {type === 'powerbiModule' || type === 'powerbi' ? (
          <Option value={FixedRatios.AUTO} key={`${FixedRatios.AUTO}-${3}`}>
            <div className="role-name">Auto</div>
            <div className="role-description">
              Fit the report to fill the available space
            </div>
          </Option>
        ) : null}
        {RatioSelectorOptions.map((o, i) => (
          <Option value={o.value} key={`${o.value}-${i}`}>
            <div className="role-name">{o.label}</div>
            <div className="role-description">{o.description}</div>
          </Option>
        ))}
      </Select>
    );
  }),
);

export default RatioCellRenderer;
